import * as actions from "./actionTypes";

const setSignIn = (payload) => {
  return {
    type: actions.AUTH,
    payload,
  };
};

const setSpareAccessRights = (payload) => {
  return {
    type: actions.SPARE_ACCESS_RIGHTS,
    payload,
  };
};

const setTechnicalDocAccessRights = (payload) => {
  return {
    type: actions.TECHNICAL_DOC_ACCESS_RIGHTS,
    payload,
  };
};

const setAdvisoriesAccessRights = (payload) => {
  return {
    type: actions.ADVISORIES_ACCESS_RIGHTS,
    payload,
  };
};

const setNotificationsAccessRights = (payload) => {
  return {
    type: actions.NOTIFICATIONS_ACCESS_RIGHTS,
    payload,
  };
};
const setNotificationsReadStatus = (payload) => {
  return {
    type: actions.NOTIFICATION_READ_STATUS,
    payload,
  };
};
const setNotificationsCount = (payload) => {
  return {
    type: actions.SET_NOTIFICATION_COUNT,
    payload,
  };
};
const logout = () => {
  return {
    type: actions.LOGOUT_USER,
  };
};
const cleanInitialState = () => {
  return {
    type: actions.CLEAN_STATE,
  };
};
const setkeyAndIv = (payload) => {
  return {
    type: actions.KEY_AND_IV,
    payload,
  };    
};
const setRollList = (payload) => {
  return {
    type: actions.SET_ROLL_LIST,
    payload,
  };    
};
const setModelSearchBrand = (payload) => {
  return {
    type: actions.SET_MODEL_SEARCH_BRAND,
    payload,
  };    
};
const setModelSearchBrick = (payload) => { 
  return {
    type: actions.SET_MODEL_SEARCH_BRICK,
    payload,
  };    
};
const setModelSearchModel = (payload) => {
  return {
    type: actions.SET_MODEL_SEARCH_MODEL,
    payload,
  };    
};



const setVendorSearch_ = (payload) => {
  return {
    type: actions.SET_SPARE_SEARCH_VENDOR,
    payload,
  };    
};
const setActionSearch_ = (payload) => {
  return {
    type: actions.SET_SPARE_SEARCH_ACTION,
    payload,
  };    
};
const setBrandSearch_ = (payload) => {
  return {
    type: actions.SET_SPARE_SEARCH_BRAND,
    payload,
  };    
};
const setBrickSearch_ = (payload) => {
  return {
    type: actions.SET_SPARE_SEARCH_BRICK,
    payload,
  };    
};
const setPartTypeSearch_ = (payload) => {
  return {
    type: actions.SET_SPARE_SEARCH_PTYPE,
    payload,
  };    
};
const setActiveSearch_ = (payload) => {
  return {
    type: actions.SET_SPARE_SEARCH_ACTIVE,
    payload,
  };    
};
const setSearchModelNameValue_ = (payload) => {
  return {
    type: actions.SET_SPARE_SEARCH_MODEL,
    payload,
  };    
};
const setSearchArticleCodeValue_ = (payload) => {
  return {
    type: actions.SET_SPARE_SEARCH_ARTICLE,
    payload,
  };    
};
const setSearchDescriptionValue_ = (payload) => {
  return {
    type: actions.SET_SPARE_SEARCH_DESCR,
    payload,
  };    
};
export {
  setSignIn,
  setSpareAccessRights,
  setTechnicalDocAccessRights,
  setAdvisoriesAccessRights,
  setNotificationsAccessRights,
  setNotificationsReadStatus,
  logout,
  cleanInitialState,
  setkeyAndIv,
  setNotificationsCount,
  setRollList,
  setModelSearchBrand,
  setModelSearchBrick,
  setModelSearchModel,

  setVendorSearch_, setActionSearch_, setBrandSearch_, setBrickSearch_, setPartTypeSearch_, setActiveSearch_, setSearchModelNameValue_, setSearchArticleCodeValue_, setSearchDescriptionValue_
};
